"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M12 9c-3.15 0-6 2.41-6 6.15q0 3.735 6 8.85 6-5.115 6-8.85C18 11.41 15.15 9 12 9m0 7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5M12 4c1.93 0 3.68.78 4.95 2.05l-1.41 1.41C14.63 6.56 13.38 6 12 6s-2.63.56-3.54 1.46L7.05 6.05C8.32 4.78 10.07 4 12 4m7.78-.77-1.41 1.41C16.74 3.01 14.49 2 12.01 2S7.27 3.01 5.64 4.63L4.22 3.22C6.22 1.23 8.97 0 12.01 0s5.78 1.23 7.77 3.23"
}), 'EmergencyShareSharp');